import React from "react";
import { Route, Routes as Switch } from "react-router-dom";

import Login from "./pages/Login/";
import ForgetPassword from "./pages/ForgetPassword/";
import ChoiceNewPassword from "./pages/ChoiceNewPassword";
import Search from "./pages/Search/";
import Mapa from "./pages/Mapa/";
import About from "./pages/About/";
import Reports from "./pages/Reports/";
import ReportsFilters from "./pages/Reports";
import Dashboard from "./pages/Dashboard/";
import Dashboard2 from "./pages/Dashboard2/";
import Details from "./pages/Details/";
import NoLocationComplaints from "./pages/NoLocationComplaints";
import ResolvedComplaints from "./pages/ResolvedCompaints";
import UserEdit from "./pages/UserEdit";
import UserRegister from "./pages/UserRegister";
import Group from "./pages/Group";
import CategoryRegister from "./pages/CategoryRegister";
import Sidebar from "./components/Sidebar";
import Footer from "./components/Footer";
import GroupEdit from "./pages/GroupEdit";
import InterruptionRegister from "./pages/InterruptionRegister";
import Maintenance from "./pages/Maintenance";
import LateComplaints from "./pages/LateComplaints";
import CategoryEdit from "./pages/CategoryEdit";
import InterruptionEdit from "./pages/InterruptionEdit/InterruptionEdit";
import StatusRegister from "./pages/StatusRegister/StatusRegister";
import StatusEdit from "./pages/StatusEdit";
import MapProvider from "./contexts/MapFilterContext";
import ListOperations from "./pages/ListOperations";
import MapaSatisfacao from "./pages/MapaSatisfacao";
import ServiceOrderRegister from "./pages/ServiceOrderRegister";
import MyServiceOrders from "./pages/MyServiceOrders";
import ServiceOrderDetails from "./pages/ServiceOrderDetails";
import ManageServiceOrders from "./pages/ManageServiceOrders";
import MaterialRegister from "./pages/MaterialRegister";

/* Não necessita de verificar a autorização, pois o compontente Header, o faz */
const PrivateRoute = ({ element: Element, ...rest }) => (
  <Sidebar>
    <div style={{ minHeight: "72vh" }}>
      <MapProvider>
        <Element />
      </MapProvider>
    </div>
    <Footer />
  </Sidebar>
);

export default function Routes() {
  const isInMaintaince = ["sim", "1", "s", "yes", "y", "true", "t"].includes(
    process.env.REACT_APP_MAINTENANCE ?? ""
  );
  if (isInMaintaince) {
    return (
      <Switch>
        <Route path="/" element={<Maintenance />} />
      </Switch>
    );
  }
  return (
    <>
      <Switch>
        {/* Rotas acessadas sem autenticação */}
        <Route path="/" exact element={<Login />} />
        <Route path="/signup" element={<h1>SignUp</h1>} />
        <Route path="/choice-new-password" element={<ChoiceNewPassword />} />
        <Route path="/forget-password" element={<ForgetPassword />} />

        {/* Rotas acessadas somente com autenticação */}
        <Route
          path="/dashboard"
          element={<PrivateRoute element={Dashboard} />}
        />
        <Route
          path="/dashboard2"
          element={<PrivateRoute element={Dashboard2} />}
        />
        <Route path="/search" element={<PrivateRoute element={Search} />} />
        <Route path="/map" element={<PrivateRoute element={Mapa} />} />
        <Route path="/map2" element={<PrivateRoute element={MapaSatisfacao}/>}/>
        <Route path="/about" element={<PrivateRoute element={About} />} />
        <Route
          path="/list-operations"
          element={<PrivateRoute element={ListOperations} />}
        />
        <Route
          path="/resolved-complaints"
          element={<PrivateRoute element={ResolvedComplaints} />}
        />
        <Route
          path="/no-location-complaints"
          element={<PrivateRoute element={NoLocationComplaints} />}
        />
        <Route
          path="/late-complaints"
          element={<PrivateRoute element={LateComplaints} />}
        />
        <Route
          path="/userregister"
          element={<PrivateRoute element={UserRegister} />}
        />
        <Route
          path="/groupregister"
          element={<PrivateRoute element={Group} />}
        />
        <Route path="/reports" element={<PrivateRoute element={Reports} />} />
        <Route
          path="/reports-filters"
          element={<PrivateRoute element={ReportsFilters} />}
        />
        <Route
          path="/useredit/:id"
          element={<PrivateRoute element={UserEdit} />}
        />
        <Route
          path="/groupedit/:id"
          element={<PrivateRoute element={GroupEdit} />}
        />
        <Route
          path="/interruptionedit/:id"
          element={<PrivateRoute element={InterruptionEdit} />}
        />
        <Route
          path="/categoryregister"
          element={<PrivateRoute element={CategoryRegister} />}
        />
        <Route
          path="/type-edit/:id"
          element={<PrivateRoute element={CategoryEdit} />}
        />
        <Route
          path="/interruptionregister"
          element={<PrivateRoute element={InterruptionRegister} />}
        />
        <Route
          path="/statusregister"
          element={<PrivateRoute element={StatusRegister} />}
        />

        <Route
          path="/materialregister"
          element={<PrivateRoute element={MaterialRegister} />}
        />
        <Route
          path="/status/:id"
          element={<PrivateRoute element={StatusEdit} />}
        />

        <Route
          path="/service-order-register"
          element={<PrivateRoute element={ServiceOrderRegister} />}
        />

        <Route
          path="/my-service-orders"
          element={<PrivateRoute element={MyServiceOrders} />}
        />

        <Route
          path="/service-order/:id"
          element={<PrivateRoute element={ServiceOrderDetails} />}
        />

        <Route
          path="/manage-service-orders"
          element={<PrivateRoute element={ManageServiceOrders} />}
        />

        <Route
          path="/details/:id"
          element={<PrivateRoute element={Details} />}
        />

        <Route path="*" component={() => <h1>Page not found</h1>} />
      </Switch>
    </>
  );
}
